import mutations from './item/mutations';
import actions from './item/actions';
import getters from './item/getters';

const item = {
  namespaced: true,
  state: {
    item: {
      invitationCourses: [],
      code: null,
      expiresAt: null,
    },
    isLoading: false,
  },
  mutations,
  actions,
  getters,
};

export default item;
